import React, { useEffect, useState } from "react";
import { PageType } from "./Models/Enum";
import { SimpleResponse } from "./Models/ResponseModel";
import { Page_SearchRequest } from "./Models/Model";
import PageService from "./Services/pageService";
import FruitDetail from "./Pages/OurFruits/Fruitdetail/FruitDetail";
import FruitListing from "./Pages/OurFruits/FruitListing";
import PageRenderer from "./Components/PageRenderer";
import MasterService from "./Services/masterService";
import FruitCategory from "./Pages/OurFruits/FruitCategory";
import Traceablility from "./Pages/Traceability/Traceability";
import Contact from "./Pages/Contact/Contact";
import ErrorPage from "./Pages/Error";
import WhereToBuy from "./Pages/WhereToBuy/WhereToBuy";
import Technology from "./Pages/About/Technology";
import Sustainability from "./Pages/About/Sustainability";



function LandingPage() {
   const [component, setState] = useState(null)

   var pageService: PageService = PageService.getInstance();
   var strLocation = "NO LOCATION";


   useEffect(() => {
      if (typeof window !== "undefined" && typeof window !== null) {
         strLocation = window.location.href;
         getRenderPage(strLocation);
      }
   }, [window.location.href]);


   var getRenderPage = async (url: string) => {
      let req = new Page_SearchRequest();
      req.URL = url;
      try {
         let resp: SimpleResponse = await pageService.WebPage_Get(req);
         if (resp.HasError) {
            return;
         }

         if (resp.Result != null) {

            resp.Result.ContentJson = MasterService.getInstance().transformToJson(resp.Result.ContentJson);
            setRenderPage(resp.Result)

         }

      } catch (e) { }
   }

   function setRenderPage(obj = null) {
      let comp;
      switch (obj.PageTypeID) {
         case PageType.Home:
            comp = <PageRenderer data={obj} />;
            break;
         case PageType.FruitCategory:
            comp = <FruitCategory data={obj} />;
            break;
         case PageType.FruitListing:
            comp = <FruitListing data={obj} />;
            break;
         case PageType.FruitDetail:
            comp = <FruitDetail data={obj} />;
            break;
         case PageType.Contact:
            comp = <Contact data={obj} />;
            break;
         case PageType.Static:            
            if(obj.URL == "/Traceability")
               comp = <Traceablility/>;
            if(obj.URL == "/AboutUs/Technology")
               comp = <Technology/>;
            if(obj.URL == "/AboutUs/Sustainability")
               comp = <Sustainability/>;           
            break;         
         case PageType.WhereToBuy:
            comp = <WhereToBuy data={obj} />
            break;

         default:
            comp = <ErrorPage />;
            break;
      }

      setState(comp);
   }

   return (<React.Fragment>{component}</React.Fragment>)
}

export default LandingPage;